import { createFeature, createReducer, on } from '@ngrx/store';

import { RowSelectionItem } from 'app/shared/features/map-row-selector/models';

import {
    addRowToSelection,
    finishRowSelection,
    removeRowFromSelection,
    resetRowSelection,
    resumeRowSelection,
    toggleRowSelectionAndFinishIfSingleSelection,
} from './row-selection.actions';
import { initialRowSelectionState, RowSelectionState } from './row-selection.state';

export const rowSelectionFeatureKey = 'rowSelection';

const reducer = createReducer<RowSelectionState>(
    initialRowSelectionState,

    on(addRowToSelection, (state, action) => {
        const newRowSelectionItem: RowSelectionItem = {
            rowNumber: action.rowNumber,
            registrationStatus: action.registrationStatus,
        };

        return {
            rows: [
                ...state.rows.filter((r) => r.rowNumber !== newRowSelectionItem.rowNumber),
                newRowSelectionItem,
            ],
            selectionProgressState: 'in-progress',
        };
    }),
    on(removeRowFromSelection, (state, { rowNumber }) => ({
        ...state,
        rows: state.rows.filter((row) => row.rowNumber != rowNumber),
    })),
    on(finishRowSelection, (state) => {
        return { ...state, selectionProgressState: 'finished' };
    }),
    on(resetRowSelection, () => {
        return initialRowSelectionState;
    }),
    on(resumeRowSelection, (state) => {
        return { ...state, selectionProgressState: 'in-progress' };
    }),
    on(toggleRowSelectionAndFinishIfSingleSelection, (state, action) => {
        const isNewRowSelection = !state.rows?.some((selection) => selection.rowNumber === action.rowNumber);

        if (isNewRowSelection) {
            const progressState = state.rows?.length > 0 ? 'in-progress' : 'finished';

            const newRowSelectionItem: RowSelectionItem = {
                rowNumber: action.rowNumber,
                registrationStatus: 'done',
            };
            return {
                ...state,
                rows: [...state.rows, newRowSelectionItem],
                selectionProgressState: progressState,
            };
        } else {
            const rowSelectionWithoutCurrent = state.rows.filter(
                (selection) => selection.rowNumber !== action.rowNumber,
            );
            return {
                rows: rowSelectionWithoutCurrent,
                selectionProgressState:
                    rowSelectionWithoutCurrent.length === 0 ? 'not-started' : 'in-progress',
            };
        }
    }),
);

export const rowSelectionFeature = createFeature({
    name: rowSelectionFeatureKey,
    reducer,
});
